import {i18n} from '@online-offer/i18n';

/** `i18n.t` with an English fallback, so new keys render before the Phrase download lands. */
export const translateWithFallback = (
  key: string,
  fallback: string,
  options: Record<string, string | number> = {}
) => i18n.t(key, {defaultValue: fallback, ...options});
